/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from "react";
import useInterfaceConfig from "@hooks/useInterfaceConfig";

const ScriptsComponent: React.FC = () => {
  const interfaceConfig = useInterfaceConfig();

  useEffect(() => {
    if (import.meta.env.VITE_ENV === "DEV") return;

    if (!interfaceConfig.scripts) return;

    const { tag_id_google, tag_id_linkedin, tag_id_hotjar, tag_id_meta_pixel, tag_id_google_tag_manager } =
      interfaceConfig.scripts;

    // Google Analytics
    if (tag_id_google) {
      const scriptGoogle = document.createElement("script");
      scriptGoogle.async = true;
      scriptGoogle.src = `https://www.googletagmanager.com/gtag/js?id=${tag_id_google}`;
      document.head.appendChild(scriptGoogle);

      scriptGoogle.onload = () => {
        const scriptInline = document.createElement("script");
        scriptInline.innerHTML = `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${tag_id_google}');
        `;
        document.head.appendChild(scriptInline);
      };
    }

    // LinkedIn
    if (tag_id_linkedin) {
      const linkedinScript = document.createElement("script");
      linkedinScript.type = "text/javascript";
      linkedinScript.innerHTML = `
        _linkedin_partner_id = "${tag_id_linkedin}";
        window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
        window._linkedin_data_partner_ids.push(_linkedin_partner_id);
        (function(l) {
          if (!l){window.lintrk = function(a,b){window.lintrk.q.push([a,b])}; window.lintrk.q=[]}
          var s = document.getElementsByTagName("script")[0];
          var b = document.createElement("script");
          b.type = "text/javascript";b.async = true;
          b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
          s.parentNode.insertBefore(b, s);
        })(window.lintrk);
      `;
      document.head.appendChild(linkedinScript);
    }

    // Hotjar
    if (tag_id_hotjar) {
      const hotjarScript = document.createElement("script");
      hotjarScript.innerHTML = `
        (function(h,o,t,j,a,r){
          h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
          h._hjSettings={hjid:${tag_id_hotjar},hjsv:6};
          a=o.getElementsByTagName('head')[0];
          r=o.createElement('script');r.async=1;
          r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
          a.appendChild(r);
        })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
      `;
      document.head.appendChild(hotjarScript);
    }

    // Meta Pixel
    if (tag_id_meta_pixel) {
      const metaPixelScript = document.createElement("script");
      metaPixelScript.innerHTML = `
        !function(f,b,e,v,n,t,s) {
          if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s);
        }(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '${tag_id_meta_pixel}');
        fbq('track', 'PageView');
      `;
      document.head.appendChild(metaPixelScript);

      const noscript = document.createElement("noscript");
      noscript.innerHTML = `
        <img height="1" width="1" style="display:none"
        src="https://www.facebook.com/tr?id=${tag_id_meta_pixel}&ev=PageView&noscript=1"/>
      `;
      document.body.appendChild(noscript);
    }

    // Google Tag Manager
    if (tag_id_google_tag_manager) {
      // script
      const gtmScript = document.createElement("script");
      gtmScript.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${tag_id_google_tag_manager}');`;
      document.head.appendChild(gtmScript);

      // noscript
      const noscript = document.createElement("noscript");
      noscript.innerHTML = `
        <iframe src="https://www.googletagmanager.com/ns.html?id=${tag_id_google_tag_manager}"
        height="0" width="0" style="display:none;visibility:hidden"></iframe>
      `;
      document.body.appendChild(noscript);
    }
  }, [interfaceConfig]);

  return null;
};

export default ScriptsComponent;
